<template>
  <div class="mt-8">
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-card elevation="6">
        <v-slide-x-reverse-transition>
          <v-alert type="success" class="alert" v-if="alert_success === true">ย้ายสินค้าสำเร็จ !</v-alert>
        </v-slide-x-reverse-transition>
        <DamagedTitle :title="item_name" :price="total" :type="unit_main"/>
        <div class="pa-2">
          <v-card-title>
            <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="detailHeaders" :items="item_lots" :search="search" :footer-props="footer_Props" mobile-breakpoint="0">
            <template slot="item" slot-scope="dataDetail">
              <tr>
                <td>{{ dataDetail.item.lot_no }}</td>
                <td>{{ item_name = dataDetail.item.product_name }}</td>
                <td>{{ dataDetail.item.date_expired }}</td>
                <td>{{ format_number(dataDetail.item.quantity) }}</td>
                <td>{{ item_unit = unit_main }}</td>
                <td>
                  <div v-if="dataDetail.item.note !== null">{{ dataDetail.item.note }}</div>
                  <div v-else>-</div>
                </td>
                <td>{{ dataDetail.item.supplier }}</td>
                <td><v-btn @click="get_moveStock(dataDetail.item.quantity, dataDetail.item.po_id, dataDetail.item.warehouse_id, dataDetail.item.product_id, dataDetail.item.lot_no, dataDetail.item.choices)" class="pa-6 ma-2 grad-success-bg white--text"><v-icon>mdi-arrow-up-left</v-icon> ย้ายคลัง</v-btn></td>
              </tr>
            </template>
          </v-data-table>
        </div>
        <v-dialog v-model="move_stock" persistent max-width="650">
          <v-card>
            <v-form ref="add_form" @submit.prevent="send_data">
              <v-card-title>
                การย้ายคลัง (คงเหลือ {{ move_storage.quantity_get }} {{ item_unit }})
              </v-card-title>

              <v-card-text>
                <div class="mb-6">
                  <div class="d-flex">
                    <v-icon>mdi-document</v-icon>
                    <div class="ml-1">คลังที่ต้องการย้าย</div>
                  </div>
                  <div class="grid_full">
                    <div class="mt-3 mr-1">
                      <v-select color="#86bc3a" :items="item_in" item-text="name" item-value="id" label="กรุณาเลือกคลังที่ต้องการย้าย" :rules="[v => !!v || 'กรุณาเลือกคลังที่ต้องการย้าย']" v-model="move_storage.stock_select" hide-details="auto" required outlined></v-select>
                    </div>
                  </div>
                </div>
                <div class="mb-6">
                  <div class="d-flex">
                    <v-icon>mdi-document</v-icon>
                    <div class="ml-1">จำนวนสินค้า</div>
                  </div>
                  <div class="grid_full">
                    <div class="mt-3 mr-1">
                      <v-text-field color="#86bc3a" label="กรุณากรอกจำนวนสินค้า" :rules="[v => !!v || 'กรุณากรอกจำนวนสินค้า']" @keypress="onlyNumber($event)" hide-details="auto" required v-model="move_storage.qty" outlined></v-text-field>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="d-flex">
                    <v-icon>mdi-document</v-icon>
                    <div class="ml-1">สาเหตุการย้ายคลัง</div>
                  </div>
                  <div class="grid_full">
                    <div class="mt-3 mr-1">
                      <v-textarea color="#86bc3a" outlined label="กรุณากรอกสาเหตุการย้ายคลัง" :rules="[v => !!v || 'กรุณากรอกสาเหตุการย้ายคลัง']" hide-details="auto" required v-model="move_storage.cause_note"></v-textarea>
                    </div>
                  </div>
                </div>
              </v-card-text>
              <v-spacer></v-spacer>
              <div class="text-center pa-4">
                <v-btn large class="grad-success-bg white--text mr-3" type="submit" style="font-size: 18px">
                  บันทึก
                </v-btn>
                <v-btn large class="grad-danger-bg white--text" type="button" style="font-size: 18px" @click="move_stock = false">
                  ยกเลิก
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>
      </v-card>
    </div>
  </div>
</template>

<script>
import DamagedTitle from "./header_damaged/DamagedTitle";
import {HTTP} from "@/axios";
import {formatNumber, formatPrice, onlyForNumber} from "@/js/handler";
import Swal from "sweetalert2";
export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Damaged_details",
  components: {DamagedTitle},
  data() {
    return {
      loading_page: false,
      search: null,
      item_in: null,
      item_name: null,
      item_unit: null,
      unit_main: null,
      move_stock: false,
      alert_success: false,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      move_storage: {
        stock_select: null,
        qty: 1,
        cause_note: null,
        import_id: null,
        importlists_id: null,
        product_id: null,
        warehouse_id: null,
        lot_no: null,
        po_id: null,
        quantity_get: null,
      },
      detailHeaders: [
        {
          text: 'ล็อตสินค้า',
          value: 'lot_no',
          fixed: true,
          width: '140px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '350px',
        },
        {
          text: 'วันหมดอายุ',
          value: 'date_expired',
          fixed: true,
          width: '150px',
        },
        {
          text: 'จำนวนคงเหลือ',
          value: 'quantity',
          fixed: true,
          width: '170px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'หมายเหตุ',
          value: 'note',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ซัพพลายเออร์',
          value: 'supplier',
          fixed: true,
          width: '250px',
        },
        {
          text: 'จัดการ',
          value: '',
          sortable: false,
          fixed: true,
          width: '120px',
        },
      ],
      item_lots: [],
      items: [
        {id: 1, name: 'คลังหลัก'},
        {id: 2, name: 'คลังรอคืน'},
        {id: 3, name: 'คลังทิ้ง'},
      ]
    }
  },
  methods: {
    onlyNumber: function(evt) {
      return onlyForNumber(evt)
    },
    format_price: function(value) {
      return formatPrice(value)
    },
    format_number: function(value) {
      return formatNumber(value)
    },
    diffDateTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0]) + 543
      return day+'/'+month+'/'+year
    },
    get_moveStock(quantity, po_id, warehouse_id, product_id, lot_no, items_in) {
      this.move_stock = true
      this.move_storage.quantity_get = quantity
      this.move_storage.po_id = po_id
      this.move_storage.warehouse_id = warehouse_id
      this.move_storage.product_id = product_id
      this.move_storage.lot_no = lot_no
      this.item_in = items_in
    },
    get_data() {
      this.loading_page = true
      HTTP.post('/inventory/damages/getdmgproduct', {
        product_id: this.$route.params.id,
        warehouse: 2,
        user_id: this.$store.state.userDetail.id,
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.item_lots = res.data.object.products
          this.unit_main = res.data.object.unit_main
        }
      })
    },
    send_data() {
      if (this.$refs.add_form.validate()) {
        if (this.move_storage.qty > 0) {
          HTTP.post('/inventory/damages/movedamage', {
            user_create: this.$store.state.userDetail.id,
            user_name: this.$store.state.userDetail.name,
            from_warehouse: 'คลังชำรุด',
            po_id: this.move_storage.po_id,
            import_id: this.move_storage.import_id,
            importlists_id: this.move_storage.importlists_id,
            warehouse_id: this.move_storage.warehouse_id,
            product_id: this.move_storage.product_id,
            lot_no: this.move_storage.lot_no,
            stock_move_id: this.move_storage.stock_select,
            qty: this.move_storage.qty,
            cause_note: this.move_storage.cause_note,
          }).then((res) => {
            if (res.data.success === true) {
              this.move_stock = false
              this.alert_success = true
              setTimeout(() => this.alert_success = false, 1000)
              this.move_storage.stock_select = null
              this.move_storage.qty = null
              this.move_storage.cause_note = null
              this.get_data()
            }
            else if (res.data.success === false) {
              Swal.fire({
                text: res.data.message,
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              }).then(() => {
                this.move_storage.qty = null
              })
            }
          })
        }
        else {
          Swal.fire({
            text: 'จำนวนสินค้าที่ต้องการย้ายต้องมาก 0 !',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.move_storage.qty = null
          })
        }
      }
    },
    getDetails(id) {
      this.$router.push('' + id)
    }
  },
  computed: {
    total() {
      let data_list = this.item_lots;
      const result = data_list.reduce((sum,number) => {
        return sum+(number.quantity);
      }, 0)
      return result
    }
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.grid_unit {
  display: grid;
  grid-template-columns: 50% 50%;
}
</style>
